import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../../../global";

const CountryBorder = ({ countryCode = "somalia" }) => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.language === "ar";
  const backgroundImage = `${imageBaseUrl}background_border.svg`;

  const styles = {
    container: {
      backgroundColor: globalStyles.colors.army_green,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "scroll",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: globalStyles.colors.white,
      position: "relative",
      overflow: "hidden",
      direction: isRTL ? "rtl" : "ltr",
      minHeight: {
        xs: "96px",
        sm: "110px",
        md: "120px",
        lg: "140px",
        xl: "160px",
      },
      py: 6,
      px: {
        xs: 1,
        sm: 2,
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundSize: {
          xs: "contain",
          sm: "cover",
          md: "cover",
        },
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        opacity: 0.8,
        zIndex: 1,
      },
    },
    text: {
      fontWeight: 600,
      fontSize: { xs: "24px", sm: "38px", md: "40px" },
      color: globalStyles.colors.white,
      textAlign: "center",
      lineHeight: "auto",
      textTransform: "uppercase",
      px: 1,
      position: "relative",
      zIndex: 2,
      letterSpacing: "1%",
    },
    contentWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      zIndex: 2,
      position: "relative",
      gap: 2,
    },
    button: {
      backgroundColor: globalStyles.colors.uclean_green,
      color: globalStyles.colors.white,
      fontFamily: globalStyles.fonts.primary,
      fontWeight: 500,
      fontSize: { xs: "15px", sm: "18px", md: "20px" }, // Responsive font size
      textTransform: "none",
      width: { xs: "50%", sm: "220px", md: "240px" }, // Fixed width, full width on mobile
      height: { xs: "44px", sm: "48px", md: "52px" }, // Fixed height
      px: 0, // Remove horizontal padding since width is fixed
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: globalStyles.colors.army_green,
        color: globalStyles.colors.white,
      }
    },
  };

  // Split the text for 2-line appearance (after comma)
  const text = t("countryBandGlobal.text");
  let lines = text.split(",");
  if (lines.length === 1) {
    // fallback: try splitting at ~40 chars
    const idx = text.indexOf(" ", Math.floor(text.length / 2));
    lines = [text.substring(0, idx), text.substring(idx + 1)];
  }

  return (
    <Box
      sx={{
        ...styles.container,
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <Box sx={styles.contentWrapper}>
        <Typography variant="h1_gothic" sx={styles.text}>
          {t("countryBorder.text")}
        </Typography>
        <Button
          sx={styles.button}
          href="https://play.google.com/store/apps/details?id=com.ucleanlaundry&hl=en_IN&pli=1"
        >
          <span style={{ transform: isRTL ? "scaleX(-1)" : "none" }}>
            {t("countryBorder.buttonText")}
          </span>
        </Button>
      </Box>
    </Box>
  );
};

export default CountryBorder;
